module.exports = __webpack_public_path__ + "static/media/IconConfirmFiltro.a1dc309a.svg";